<template>
    <div :contenteditable="editable" @input="input">
        {{value}}
    </div>
</template>
<script>
export default {
    name: 'EditableTextBlock',
    props: {
        value: {
            type: String,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {}
    },
    computed: {},
    methods: {
        input() {
            this.$emit('change', this.$el.textContent);
        }
    }
}
</script>
